<template>
  <div class="article-view">
    <div class="search-pg">
      <Search />
    </div>
    <div class="container">
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs" />
      </div>
      <div class="position">
        <div
          v-if="
                article.parent && !article.parent.hide_tab && tabs && tabs.children
              "
          class="tabs-main"
        >
          <v-tabs centered>
            <v-tab
              v-for="tab in tabs.children"
              :key="tab.id"
              :slug="tab.slug"
              :class="{ 'v-tab--active': tab.slug === article.slug }"
              :to="{ params: { slug: tab.slug } }"
            >
              {{ tab.transTitle }}
            </v-tab>
          </v-tabs>
        </div>
        <div class="bg-white p-20">
          <div v-if="article">
            <h1 v-if="!article.hide_title" class="title-pg">
              {{ article.transTitle }}
            </h1>
            <div
              v-if="!article.hide_content"
              class="content"
              v-html="article.transContent"
            ></div>

            <div class="share-soc">
              <div class="share-icons">
                <Social
                  :title="article.transTitle"
                  :quote="article.transTitle"
                  :url="currentUrl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CMS from '@/model/cms'
import Search from '@/components/Search'
import {Trans} from "@/plugins/Translation"
import Social from "@/components/Social"

export default {
  components: {
    Search,
    Social
  },
  data: () => ({
    article: null,
    breadcrumbs: [],
    tabs: null,
    title: '',
    description: '',
    keywords: '',
    currentUrl: ''
  }),
  metaInfo () {
    return {
      title: this.title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.description,
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.keywords,
      }]
    }
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    '$route.params.slug': 'fetchData'
  },
  created() {
    this.fetchData()
    this.currentUrl = window.location.href
    this.scrollToTop()
  },
  methods: {
    fetchData() {
      CMS.loadPageBySlug(this.$route.params.slug)
        .then((response) => {
          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: Trans.currentLocaleUrl + '/'
            }
          ]
          this.article = response.data
          if (this.article) {
            if (this.article.parent) {
              var ParentBreadcrumb = {}
              ParentBreadcrumb.text = this.article.parent.transTitle
              ParentBreadcrumb.disabled = false
              ParentBreadcrumb.href = Trans.currentLocaleUrl + '/blog/' + this.article.parent.slug
              this.breadcrumbs.push(ParentBreadcrumb)
              if (this.article.parent.hide_tab === false) {
                CMS.loadBlogBySlug(this.article.parent.slug)
                  .then((response) => {
                    this.tabs = response.data
                  })
                  .catch((error) => {
                    console.log(error)
                  })
              }
            }
            var breadcrumb = {}
            breadcrumb.text = this.article.transTitle
            breadcrumb.disabled = true
            this.breadcrumbs.push(breadcrumb)
            this.title = this.article.transTitle
            this.description = this.article.transDescription
            this.keywords = this.article.transKeywords
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs-main {
  margin-bottom: 0;
  .v-tabs:not(.v-tabs--vertical) {
    .v-tab {
      max-width: 32%;
      margin-right: 0;
    }
  }
}
</style>
